import { Component, OnInit } from '@angular/core';
import { SimpleViewModel } from '@app/models/SimpleViewModel';
import { HttpClient } from '@angular/common/http';
import { UserReportViewModel } from '@app/models/UserReportViewModel';
import { ReportService } from '@app/services/report.service';
import { DatepickerDefaultOptions } from '../../../DatepickerDefaultOptions';

@Component({
  selector: 'app-user-report',
  templateUrl: './user-report.component.html',
  styleUrls: ['./user-report.component.css']
})
export class UserReportComponent implements OnInit {

  constructor(
    private http: HttpClient,
    private reportService: ReportService,
    private datePickerDefaultOptions: DatepickerDefaultOptions
  ) { }

  datepickerConfig = this.datePickerDefaultOptions.defaults
  report: UserReportViewModel = new UserReportViewModel()
  dropdownSettings = {}

  users: SimpleViewModel[] = []
  selectedUsers: SimpleViewModel[] = []

  isPrinting: boolean = false

  userSelectChange() {
    this.report.userIds = this.selectedUsers.map(x => x.id)
  }

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Välj alla',
      unSelectAllText: 'Ta bort alla',
      itemsShowLimit: 10,
      allowSearchFilter: true,
      enableCheckAll: true
    };
  }

  ngAfterViewInit() {
    this.http.get<SimpleViewModel[]>("/api/userProfile/getActiveEmployees")
      .subscribe(data => {
        this.users = data;
      })
  }

  print(): void {
    let self = this
    self.isPrinting = true
    this.reportService.downloadPdf(
      'api/report/userReport',
      this.report,
      'Avstämningsrapport_användare_' + +new Date() + '.pdf',
      function (success) {
        self.isPrinting = false
      })
  }
}
